import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BADGE_IMAGES = {
  shorts: '/badge_shorts.png',
  basicos: '/badge_basicos.png',
  avanzados: '/badge_avanzados.png',
  psicotrading: '/badge_psicotrading.png',
  algoritmos: '/badge_algoritmos.png',
};

const SIZES = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
};

export function UserBadges({ badges, size = 'sm' }) {
  if (!badges || badges.length === 0) return null;
  return (
    <div className="flex items-center space-x-1" data-testid="user-badges">
      {badges.map(b => (
        <img
          key={b}
          src={BADGE_IMAGES[b]}
          alt={b}
          title={`Insignia: ${b.charAt(0).toUpperCase() + b.slice(1)}`}
          className={`${SIZES[size] || SIZES.sm} rounded-full object-cover ring-2 ring-emerald-500/30`}
        />
      ))}
    </div>
  );
}

export function UserBadgesLoader({ size = 'sm' }) {
  const { user } = useAuth();
  const [badges, setBadges] = useState([]);

  useEffect(() => {
    if (!user?.id) return;
    axios.get(`${API}/badges/${user.id}`).then(res => {
      setBadges(res.data.badges || []);
    }).catch(() => {});
  }, [user?.id]);

  return <UserBadges badges={badges} size={size} />;
}
